var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "NotificationBanner",
        { attrs: { storageKey: _vm.maintenanceDateTimestampString } },
        [
          _vm._v(
            "\n  " +
              _vm._s(_vm.formattedMessage) +
              "\n  If you have any questions, please contact us at "
          ),
          _c("a", { attrs: { href: _vm.supportEmail } }, [
            _vm._v("support@traackr.com")
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }